import { render, staticRenderFns } from "./NotificationTypeCardGrid.vue?vue&type=template&id=47c18225"
import script from "./NotificationTypeCardGrid.vue?vue&type=script&lang=js"
export * from "./NotificationTypeCardGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports